import InputText from 'bloko/blocks/inputText';

import useTrls from 'hooks/translation/useTrls';

import ClickmeFormItem from 'components/ClickmeFormItem';

import { setPayerDocAddress } from 'store/models/payerCreate';
import { useDispatch, useSelector } from 'store/utils';

const PayerLegalDocAddress = () => {
    const dispatch = useDispatch();
    const { payerDocAddress, payerErrors } = useSelector((state) => state.payerCreate);
    const trl = useTrls();

    return (
        <ClickmeFormItem
            input={
                <InputText
                    value={payerDocAddress}
                    onChange={(value) => dispatch(setPayerDocAddress(value))}
                    placeholder={trl('InvoiceAndPayerForm.PayerCreate.PayerLegalDocAddress.placeholder')}
                    invalid={Boolean(payerErrors.post)}
                    data-qa="post"
                />
            }
            legend={trl('InvoiceAndPayerForm.PayerCreate.PayerLegalDocAddress.legend')}
            hint={trl('InvoiceAndPayerForm.PayerCreate.PayerLegalDocAddress.hint')}
            isRequired
            error={payerErrors.post}
        />
    );
};

export default PayerLegalDocAddress;
